<template>
	<HomeIcon v-if="icon === 'home'" />
	<CloseIcon v-else-if="icon === 'close'" />
	<ChevronRightIcon v-if="icon === 'chevron-right'" />
	<ChevronUpIcon v-if="icon === 'chevron-up'" />
	<ChevronDownIcon v-if="icon === 'chevron-down'" />
	<ChevronLeftIcon v-if="icon === 'chevron-left'" />
	<MenuIcon v-if="icon === 'hamburger'" />
	<CheckIcon v-if="icon === 'check'" />
	<CheckCircleIcon v-if="icon === 'check-circle'" />
	<EyeIcon v-if="icon === 'view'" />
	<PencilOutlineIcon v-if="icon === 'edit'" />
	<ArrowLeftIcon v-if="icon === 'arrow-left'" />
	<AccountOutlineIcon v-if="icon === 'person'" />
	<AlertCircleIcon v-if="icon === 'alert-circle'" />
	<AlertIcon v-if="icon === 'alert'" />
	<InformationIcon v-if="icon === 'information'" />
	<AttachmentIcon v-if="icon === 'attachment'" />
	<DeleteOutlineIcon v-if="icon === 'delete'" />
	<CalendarIcon v-if="icon === 'calendar'" />
	<HistoryIcon v-if="icon === 'repeatable'" />
	<MenuDownIcon v-if="icon === 'caret-down'" />
	<ImageOutlineIcon v-if="icon === 'image'" />
	<FileDocumentOutlineIcon v-if="icon === 'file-document'" />
	<FileOutlineIcon v-if="icon === 'file'" />
	<HelpCircleOutlineIcon v-if="icon === 'help'" />
	<TuneIcon v-if="icon === 'filter'" />
</template>
<script lang="ts" setup>
	/**
	 * Wrapper component for icons.
	 * This component is used to make it easier to switch between icon libraries.
	 * @see https://pictogrammers.com/library/mdi/ for an overview of available icons inside 'vue-material-design-icons'
	 */
	import type {PropType} from 'vue';
	import HomeIcon from 'vue-material-design-icons/Home.vue';
	import CloseIcon from 'vue-material-design-icons/Close.vue';
	import ChevronRightIcon from 'vue-material-design-icons/ChevronRight.vue';
	import MenuIcon from 'vue-material-design-icons/Menu.vue';
	import ChevronLeftIcon from 'vue-material-design-icons/ChevronLeft.vue';
	import ChevronUpIcon from 'vue-material-design-icons/ChevronUp.vue';
	import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue';
	import PencilOutlineIcon from 'vue-material-design-icons/PencilOutline.vue';
	import EyeIcon from 'vue-material-design-icons/Eye.vue';
	import CheckIcon from 'vue-material-design-icons/Check.vue';
	import CheckCircleIcon from 'vue-material-design-icons/CheckCircle.vue';
	import ArrowLeftIcon from 'vue-material-design-icons/ArrowLeft.vue';
	import AccountOutlineIcon from 'vue-material-design-icons/AccountOutline.vue';
	import AlertIcon from 'vue-material-design-icons/Alert.vue';
	import AlertCircleIcon from 'vue-material-design-icons/AlertCircle.vue';
	import InformationIcon from 'vue-material-design-icons/Information.vue';
	import AttachmentIcon from 'vue-material-design-icons/Attachment.vue';
	import DeleteOutlineIcon from 'vue-material-design-icons/DeleteOutline.vue';
	import HistoryIcon from 'vue-material-design-icons/History.vue';
	import CalendarIcon from 'vue-material-design-icons/Calendar.vue';
	import MenuDownIcon from 'vue-material-design-icons/MenuDown.vue';
	import ImageOutlineIcon from 'vue-material-design-icons/ImageOutline.vue';
	import FileDocumentOutlineIcon from 'vue-material-design-icons/FileDocumentOutline.vue';
	import FileOutlineIcon from 'vue-material-design-icons/FileOutline.vue';
	import HelpCircleOutlineIcon from 'vue-material-design-icons/HelpCircleOutline.vue';
	import TuneIcon from 'vue-material-design-icons/Tune.vue';
	import type {AvailableIcon} from '~/lib/types/IconTypes';

	defineProps({
		icon: {
			type: String as PropType<AvailableIcon>,
			required: true
		},
		size: {
			type: Number,
			default: null
		}
	});
</script>

<style scoped>
	:deep(svg) {
		vertical-align: middle;
		fill: var(--icon-color, currentColor);
		width: var(--icon-size, 24px);
		height: var(--icon-size, 24px);
	}
</style>
